import { SET_CREATORS_TIERS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema'

export default {
	[SET_CREATORS_TIERS]: {
		payloadSchema: cronJobPayloadSchema,
		isCron: true,
	},
}
